import { gateNames } from '@mp/constants';
import { useCurrentUser, useGate } from '@mp/hooks';
import { isSaasSchedulingAccount } from '@mp/utils';
import { useProfessionalSaasDetail } from './useProfessionalSaasDetail';

export const useSchedulingPreferencesData = () => {
  const { currentUser, isSaas } = useCurrentUser();
  const { professionalSaasDetail } = useProfessionalSaasDetail(currentUser?.professional?.id);
  const schedulingPreferencesGate = useGate(gateNames.schedulingPreferencesUi);

  const hasSaasDetails = !!professionalSaasDetail?.id;

  const preferencesLastUpdatedAt = professionalSaasDetail?.preferences_last_updated_at;

  const shouldShowSchedulingPreferences =
    isSaas && schedulingPreferencesGate && isSaasSchedulingAccount(currentUser) && hasSaasDetails;

  return {
    shouldShowSchedulingPreferences,
    preferencesLastUpdatedAt,
  };
};
